import type { Locale } from './settings';

// Returns 'one' | 'other' per locale's plural rules
export function getPluralForm(locale: Locale, count: number): 'one' | 'other' {
    const rules = new Intl.PluralRules(localeToBCP47(locale));
    const form = rules.select(count);
    // Intl.PluralRules can return 'zero' | 'one' | 'two' | 'few' | 'many' | 'other'
    // fa/en/de only meaningfully use 'one' and 'other', so collapse the rest
    return form === 'one' ? 'one' : 'other';
}

function localeToBCP47(locale: Locale): string {
    const map: Record<Locale, string> = { fa: 'fa-IR', en: 'en-US', de: 'de-DE' };
    return map[locale];
}